import React, { FC } from 'react'
import { createPortal } from 'react-dom'

import { Menu } from './Menu'

interface TableActionMenuPluginProps {
  anchorElem: HTMLElement
}

/**
 * Plugin for actions on existing tables
 */
export const TableActionMenuPlugin: FC<TableActionMenuPluginProps> = ({ anchorElem }) => createPortal(<Menu anchorElem={anchorElem} />, anchorElem)
